"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePersonRequest = void 0;
var CreatePersonRequest;
(function (CreatePersonRequest) {
    let gender;
    (function (gender) {
        gender["MALE"] = "male";
        gender["FEMALE"] = "female";
        gender["NOT_SPECIFIED"] = "not_specified";
    })(gender = CreatePersonRequest.gender || (CreatePersonRequest.gender = {}));
})(CreatePersonRequest || (exports.CreatePersonRequest = CreatePersonRequest = {}));
